import {Switch} from 'react-aria-components'

import moonSvg from '@/assets/icons/moon.svg'
import sunSvg from '@/assets/icons/sun.svg'
import {Theme} from '@/lib/theme/theme'
import useTheme from '@/lib/theme/useTheme'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

import style from './ThemeSwitcher.module.scss'

export default memo(function ThemeSwitcher() {
  const [theme, setTheme] = useTheme()

  const handleSwitchTheme = useCallback(
    (isLight: boolean) => {
      setTheme(isLight ? Theme.Light : Theme.Dark)
    },
    [setTheme],
  )

  const icon = theme === Theme.Dark ? moonSvg : sunSvg
  const text = theme === Theme.Dark ? 'Switch to light mode' : 'Switch to dark mode'

  return (
    <Switch
      isSelected={theme === Theme.Light}
      className={clsx(style.Switch, theme === Theme.Light && style.Light)}
      onChange={handleSwitchTheme}
    >
      <div className={style.SwitchHandleContainer}>
        <div className={style.SwitchHandle}>
          <img src={icon} alt='' />
        </div>
      </div>
      <VisuallyHidden>{text}</VisuallyHidden>
    </Switch>
  )
})
